import '../css/main.css';
import { initTheme } from './modules/theme.ts';
import { initNavigation } from './modules/navigation.ts';
import { initShowcaseTabs } from './modules/showcase-tabs.ts';
import { initWhatsAppRouter } from './modules/whatsapp-router.ts';
import { initCookieBanner } from './modules/cookie-banner.ts';

document.addEventListener('DOMContentLoaded', () => {
  initTheme();
  initNavigation();
  initShowcaseTabs();
  initWhatsAppRouter();
  initCookieBanner();
});
